import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Box,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TableSortLabel } from '@mui/material';
import { format, parseISO } from 'date-fns';
import { TABLE_COLUMNS } from '../constants';
import { engagementActionIcon } from '../../../../assets/engagement-action-icons';
import { capitalizeFirstLetter, getSortedData } from '../../../../utility';
import { TableRowsSkeleton } from '../../../shared';


const EngagementTypeTable = ({
    engagements,npiId, isModalDataLoading
}) => {
    const { company } = useSelector((state) => state.company);
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState(null);
    const handleRequestSort = (property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };
    const createSortHandler = (property) => () => {
        handleRequestSort(property);
    };

    const sortedData = React.useMemo(() => getSortedData(orderBy, order, engagements), [order, orderBy, engagements]);

    const engagementBackgroundColor = {
        click: '#6CE9A6', // Green
        sent: '#FEC84B', // Yellow
        impressions: '#7CD4FD', // Light Blue
        impression: '#7CD4FD', // Light Blue
        none: '#FDA29B', // Red
        view: '#FEA3B4', // Rose
        open: '#FEB273', // Orange
        clicked: '#6CE9A6', // Green
        delivered: '#FEC84B', // Yellow
        completed: '#6CE9A6' // Green
    };
    const formattedDate = (inputDate, timeZone = 'UTC') => {
        if (!inputDate) return '-';
        return format(parseISO(inputDate), 'MMM dd, yyyy');
    };
    const engagementActionIconMapping = (name) => {
        const action = name?.toLowerCase();
        return engagementActionIcon[action];
    };

    const engagementActionBackground = (action) => {
        const engagementAction = action?.toLowerCase();

        return engagementBackgroundColor[engagementAction] || '#AD509E';
    };
    const showAssetsColumn = () =>{
        const companies = [41,51,53,59,161,66,64,72,90,92];
        return companies.includes(company.id);
    };

    const showCreativeColumn = () =>{
        const companies = [];
        return companies.includes(company.id);
    };

    return (
        <TableContainer component={Paper}>
            <Table>
                <TableHead>
                    <TableRow className="bg-gray-50 w-100">
                        <TableCell
                            className="bg-gray-50 w-100 no-border"
                            colSpan={5}
                        >
                            <Typography className="text-lg-medium gray-900">
                                Engagements
                            </Typography>
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        {TABLE_COLUMNS?.map((column, index) => {
                            if (column.key === 'assets' && !showAssetsColumn()) return null;
                            if (column.key === 'creative' && !showCreativeColumn()) return null;
                            return (
                                <TableCell className="bg-primary-250" key={index}>
                                    <TableSortLabel
                                        active={orderBy === column.key}
                                        direction={orderBy === column.key ? order : 'asc'}
                                        onClick={createSortHandler(column.key)}
                                    >
                                        <Typography className="text-md-bold primary-color">
                                            {column.value}
                                        </Typography>
                                    </TableSortLabel>
                                </TableCell>
                            );
                        })}
                    </TableRow>

                </TableHead>
                <TableBody>
                    {isModalDataLoading ?
                        <TableRowsSkeleton columns={showAssetsColumn() || showCreativeColumn() ? 4 : 3 }/> :
                        !engagements || engagements.length === 0 ? (
                            <TableRow>
                                <TableCell colSpan={5}>
                                    <Typography className="text-md-bold gray-900 text-center">
                                        There is no engagement data to show
                                    </Typography>
                                </TableCell>
                            </TableRow>
                        ) : (
                            [...sortedData].map((row, index) => (
                                <TableRow key={index}>
                                    <TableCell>
                                        <Typography className="text-sm-regular gray-700">

                                            {row?.engagement_type}
                                        </Typography>
                                    </TableCell>
                                    { showAssetsColumn() ?
                                        <TableCell>
                                            <Typography className="text-sm-regular gray-700">
                                                {row?.assets}
                                            </Typography>
                                        </TableCell> : null
                                    }
                                    { showCreativeColumn() ?
                                        <TableCell>
                                            <Typography className="text-sm-regular gray-700">
                                                {row?.creative}
                                            </Typography>
                                        </TableCell> : null
                                    }

                                    <TableCell>
                                        <Typography className="text-sm-regular gray-700">
                                            {row?.action_date
                                                ? formattedDate(row?.action_date)
                                                : ''}
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Box className="flex-row-start-center gap-4">
                                            <img
                                                alt={row.action}
                                                height="18px"
                                                src={engagementActionIconMapping(
                                                    row?.action
                                                )}
                                                width="18px"
                                            />
                                            <Box
                                                className="padding-tb-2-rl-4 br-4px"
                                                sx={{
                                                    background:
                                                        engagementActionBackground(
                                                            row?.action
                                                        )
                                                }}
                                            >
                                                <Typography className="text-sm-semi-bold white">
                                                    {capitalizeFirstLetter(
                                                        row?.action
                                                    )}
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </TableCell>
                                </TableRow>
                            ))
                        )
                    }

                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default EngagementTypeTable;
